import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Textarea } from '../ui/textarea';

const AffectationsAssignDialog = ({
  isOpen, setIsOpen,
  selectedEmployeesCount,
  calendars,
  selectedCalendarId, setSelectedCalendarId,
  assignmentNotes, setAssignmentNotes,
  handleAssignCalendar,
}) => {
  const { t } = useTranslation();

  return (
  <Dialog open={isOpen} onOpenChange={setIsOpen}>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>{t('holidayAssignments.assign.title')}</DialogTitle>
        <DialogDescription>
          {t('holidayAssignments.assign.desc', { count: selectedEmployeesCount })}
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="calendar">{t('holidayAssignments.assign.calendar')}</Label>
          <Select value={selectedCalendarId} onValueChange={setSelectedCalendarId}>
            <SelectTrigger id="calendar">
              <SelectValue placeholder={t('holidayAssignments.assign.selectCalendar')} />
            </SelectTrigger>
            <SelectContent>
              {calendars.map((calendar) => (
                <SelectItem key={calendar.id} value={calendar.id.toString()}>
                  {t('holidayAssignments.assign.calendarOption', { name: calendar.name, year: calendar.year, count: calendar.holidays_count })}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="notes">{t('holidayAssignments.assign.notes')}</Label>
          <Textarea
            id="notes"
            value={assignmentNotes}
            onChange={(e) => setAssignmentNotes(e.target.value)}
            placeholder={t('holidayAssignments.assign.notesPlaceholder')}
            rows={3}
          />
        </div>

        <div className="p-3 bg-muted/30 border border-border rounded">
          <div className="flex items-start gap-2">
            <AlertCircle className="h-4 w-4 text-muted-foreground mt-0.5" />
            <p className="text-sm text-muted-foreground">
              {t('holidayAssignments.assign.reassignWarning')}
            </p>
          </div>
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => setIsOpen(false)}>{t('common.cancel')}</Button>
        <Button onClick={handleAssignCalendar} disabled={!selectedCalendarId}>{t('holidayAssignments.assign.submit')}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  );
};

export default AffectationsAssignDialog;
